import dateHelper from '../utils/portuna/dateHelper';

/**
 * parse date into given format
 *
 * @param input
 * @param format
 * @returns {string|boolean|number}
 */
export default function datetime(input: Date | string | number, format = 'd.m.Y, H:i \\U\\h\\r')
{
    return dateHelper(format, input);
};